import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";

const NAV = [
  { label: "À PROPOS", href: "#about" },
  { label: "SERVICES", href: "#services" },
  { label: "TARIFS", href: "#pricing" },
  { label: "STRUCTURES", href: "#structures" },
  { label: "PARTENAIRE", href: "#partners" },
  { label: "CONTACT", href: "#contact" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-[#050505]/85 backdrop-blur-xl border-b border-white/10"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 h-20 flex items-center justify-between">
        <a href="#hero" data-testid="nav-logo" className="flex flex-col leading-tight">
          <span className="font-display text-xl md:text-2xl tracking-[0.05em]">AYMES</span>
          <span className="text-[9px] md:text-[10px] text-[#CCFF00] uppercase tracking-[0.3em]">
            GK Coaching
          </span>
        </a>

        <nav className="hidden lg:flex items-center gap-7 xl:gap-10">
          {NAV.map((n) => (
            <a
              key={n.href}
              href={n.href}
              data-testid={`nav-link-${n.label.toLowerCase()}`}
              className="text-xs font-bold tracking-[0.2em] text-zinc-400 hover:text-white transition-colors whitespace-nowrap"
            >
              {n.label}
            </a>
          ))}
        </nav>

        <a
          href="#booking"
          data-testid="nav-cta-reserve"
          className="hidden lg:inline-flex items-center bg-[#CCFF00] text-black font-bold uppercase tracking-wide text-xs px-5 xl:px-6 py-3 rounded-sm hover:bg-white transition-colors whitespace-nowrap"
        >
          Réserver
        </a>

        <button
          data-testid="mobile-menu-toggle"
          onClick={() => setOpen((o) => !o)}
          className="lg:hidden text-white"
          aria-label="Toggle menu"
        >
          {open ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.25 }}
            className="lg:hidden bg-[#050505]/95 backdrop-blur-xl border-t border-white/10 overflow-hidden"
            data-testid="mobile-menu"
          >
            <nav className="flex flex-col px-6 py-6 gap-5">
              {NAV.map((n) => (
                <a
                  key={n.href}
                  href={n.href}
                  onClick={() => setOpen(false)}
                  className="text-sm font-bold tracking-[0.2em] text-zinc-300 hover:text-[#CCFF00]"
                >
                  {n.label}
                </a>
              ))}
              <a
                href="#booking"
                onClick={() => setOpen(false)}
                className="bg-[#CCFF00] text-black font-bold uppercase text-sm px-5 py-3 rounded-sm text-center"
              >
                Réserver une formation
              </a>
            </nav>
          </motion.div>
        )}
      </AnimatePresence>
    </header>
  );
}
